"use client";

import { useEffect } from "react";
import { ServiceUnavailable } from "@/components/ServiceUnavailable";

/**
 * Auth-route error boundary — keeps login/signup usable when a client error
 * would otherwise show Next's generic "Application error" screen.
 */
export default function AuthError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[auth-error]", error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/30 p-4">
      <ServiceUnavailable
        title="Couldn’t open this page"
        description="Sign-in is temporarily unavailable. Please try again. If this keeps happening, our servers may be down briefly."
        onRetry={reset}
      />
    </div>
  );
}
